module.exports = __webpack_public_path__ + "a0c3a0615c6cfdcf5f215993d4d2743a.svg";